export default class Fitmenu {
  constructor(selector, large = false) {
    this.selector = selector;
    this.maxWidth = false;
    this.currentBox = false;
    this.currentTextObj = false;
    this.length = large ? 9 : 18;
  }

  init() {

    let items = document.querySelectorAll(this.selector);
    for (let i=0;i< items.length; i++) {
      this.createSlices(items[i]);
    }
    let fitMenu = this;
    window.addEventListener('resize', function(event){
      fitMenu.resize();
    });
  }

  resize() {
    let items = document.getElementsByClassName('fitmenu-processed');
    for(let i =0;i<items.length;i++) {
      let lines = items[i].getElementsByTagName('span');
      for(let j =0;j<lines.length;j++) {
        this.fitTextInBox(items[i], lines[j]);
      }
    }
  }

  createSlices(obj) {
    let str = obj.innerText;
    let lines = [];
    if(str.length > this.length) {
      let substrings = str.split(' ');
      while(substrings.length) {
        let line = substrings.shift();
        while (line.length < this.length / 2 && substrings.length && (line.length + substrings[0].length) < this.length / 1.2 ) {
          line += ' ' + substrings.shift();
        }
        lines.push(line);
      }
    } else {
      lines.push(str);
    }

    obj.innerText = '';
    for(let i =0;i<lines.length;i++) {
      let div = document.createElement('div');
      div.classList.add('fitmenu-processed');
      let span = document.createElement('span');
      span.innerHTML = lines[i];
      div.appendChild(span);
      obj.appendChild(div);
      this.fitTextInBox(div, span);
    }
  }

  fitTextInBox(obj,elem)
  {
    this.maxWidth = obj.offsetWidth;
    this.currentTextObj = elem;
    this.currentBox = elem;
    this.currentTextObj.style.fontSize = '1px';
    this.fitTextInBoxAutoFit();
  }


  fitTextInBoxAutoFit()
  {
    var tmpFontSize = this.currentTextObj.style.fontSize.replace('px','')/1;
    this.currentTextObj.style.fontSize = tmpFontSize + 1 + 'px';
    var tmpWidth = this.currentTextObj.offsetWidth;
    if(tmpWidth < this.maxWidth){
      this.fitTextInBoxAutoFit();
    }else{
      this.currentTextObj.style.fontSize = this.currentTextObj.style.fontSize.replace('px','')/1 - 1 + 'px';
    }
  }


}
